/**
 * Tags chunk-error reloads so the reload-loop-breaker can identify them.
 *
 * Nuxt's `emitRouteChunkError: 'automatic-immediate'` auto-reloads on chunk
 * load failures. This hook fires before that reload, letting us set the
 * `__reload_source` sessionStorage flag.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:chunkError', () => {
    try {
      sessionStorage.setItem('__reload_source', 'chunk-error')
    } catch {
      /* sessionStorage unavailable */
    }
  })
})
